import {
	FETCH_USER_CHECKINOUT_REQUEST,
	FETCH_USER_CHECKINOUT_SUCCESS,
	FETCH_USER_CHECKINOUT_FAILURE,
} from '../../constants';

const initialState = {
	userCheckInOut: [],
	loading: false,
	error: null,
};

const userCheckInOutReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_USER_CHECKINOUT_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				userCheckInOut: []
			};
		case FETCH_USER_CHECKINOUT_SUCCESS:
			return {
				...state,
				userCheckInOut: action.payload,
				loading: false,
				error: null,
			};
		case FETCH_USER_CHECKINOUT_FAILURE:
			return {
				...state,
				userCheckInOut: [],
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export default userCheckInOutReducer;
